import { apiConstants } from '../../common/constants'
import ChannelConfigCard from './ChannelConfigCard';

const ChannelOrderVerification = ({ merchantId, setReload, data }) => (
    <ChannelConfigCard
        merchantId={merchantId}
        setReload={setReload}
        data={data}
        pricingType="channel_orders_confirmation_WA"
        endpoint={apiConstants.CHANNEL_ORDER_VERIFICATION}
        configType="channel_orders_confirmation_WA"
        title="Order Confirmation WhatsApp (Webstore Orders)"
        description="Confirm the order details with the customer on WhatsApp before processing."
        unitLabel="confirmation message sent"
    />
);

export default ChannelOrderVerification;
